module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABdUExURUxpcQPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqAPXqP///+n8+CndtkvjwYPr1Lf05tr688/47jTfuYzt2ML26qfx4Q/ZrRnbsHXpz2zozEu0NBMAAAAOdFJOUwCzefrRayDx4wgREth4d7w1CQAAALFJREFUGNN1kecOwyAMhM0qZNQmg+z2/R+zBEizlPuB0CfZZ/sAgnLFjNAlUznsyrjGJM2zjb4kHiRfiRo8yQSeSbxIrn3eeBMHKPQd6wLUBVXthKiAnWnfkUNkcB6jd+R6PwyItbBOtHbUeYoCVsfRNpFa6ioMuPTvQNQcqW8SLBuiYfZ0jNRbxgE9by21S/JQ2zofIpqWfR3g8fu103xY/ulUD4d9iuEptC1iYf4R/wAjPhWIKqvRUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/upload_finished.png
// module id = ptx6
// module chunks = 38